
function $parcel$export(e, n, v, s) {
  Object.defineProperty(e, n, {get: v, set: s, enumerable: true, configurable: true});
}

      var $parcel$global = globalThis;
    
var $parcel$modules = {};
var $parcel$inits = {};

var parcelRequire = $parcel$global["parcelRequireeff3"];

if (parcelRequire == null) {
  parcelRequire = function(id) {
    if (id in $parcel$modules) {
      return $parcel$modules[id].exports;
    }
    if (id in $parcel$inits) {
      var init = $parcel$inits[id];
      delete $parcel$inits[id];
      var module = {id: id, exports: {}};
      $parcel$modules[id] = module;
      init.call(module.exports, module, module.exports);
      return module.exports;
    }
    var err = new Error("Cannot find module '" + id + "'");
    err.code = 'MODULE_NOT_FOUND';
    throw err;
  };

  parcelRequire.register = function register(id, init) {
    $parcel$inits[id] = init;
  };

  $parcel$global["parcelRequireeff3"] = parcelRequire;
}

var parcelRegister = parcelRequire.register;
parcelRegister("a71XW", function(module, exports) {

$parcel$export(module.exports, "register", () => $75cc15303b7bd133$export$6503ec6e8aabbaf, (v) => $75cc15303b7bd133$export$6503ec6e8aabbaf = v);
var $75cc15303b7bd133$export$6503ec6e8aabbaf;
var $75cc15303b7bd133$export$f7ad0328861e2f03;
"use strict";
var $75cc15303b7bd133$var$mapping = new Map();
function $75cc15303b7bd133$var$register(baseUrl, manifest) {
    for(var i = 0; i < manifest.length - 1; i += 2)$75cc15303b7bd133$var$mapping.set(manifest[i], {
        baseUrl: baseUrl,
        path: manifest[i + 1]
    });
}
function $75cc15303b7bd133$var$resolve(id) {
    var resolved = $75cc15303b7bd133$var$mapping.get(id);
    if (resolved == null) throw new Error("Could not resolve bundle with id " + id);
    return new URL(resolved.path, resolved.baseUrl).toString();
}
$75cc15303b7bd133$export$6503ec6e8aabbaf = $75cc15303b7bd133$var$register;
$75cc15303b7bd133$export$f7ad0328861e2f03 = $75cc15303b7bd133$var$resolve;

});

var $dc2db5826e74a36c$exports = {};

(parcelRequire("a71XW")).register(new URL("", import.meta.url).toString(), JSON.parse('["3eN4u","index.551ca695.js","lFiUl","robot.df82a10b.gif","axzVm","index.54a55ff1.css"]'));


//# sourceMappingURL=index.runtime.0cf993fc.js.map
